import type { MatrixClient, Room } from "matrix-js-sdk";
import { stopRinging } from "./callRing";
import { markSelfLeftCall, noteDismissedCallNotification } from "./selfLeftCalls";
import { findActiveCallNotification, terminateActiveCall } from "./callTermination";

/**
 * Decline an active room call.  Stop every local audio path first, then send
 * both the call-scoped hangup and the MSC4310 decline reference when possible.
 *
 * ПОРЯДОК ВАЖЕН (дефект 04.10 «баннер возвращается»). Локальное гашение
 * идёт ПЕРВЫМ и полностью синхронно: отметка в selfLeftCalls ставится до
 * любого сетевого вызова. Раньше единственным способом погасить баннер было
 * увидеть в ленте свой m.call.hangup — а он при входящем звонке не
 * отправлялся вовсе, и apply() по таймеру рисовал баннер заново. Теперь
 * отказ виден локально сразу и переживает отсутствие сети и отказ сервера.
 */
export async function declineActiveCall(client: MatrixClient, room: Room): Promise<void> {
  stopRinging();
  markSelfLeftCall(room.roomId);

  // Один и тот же поиск, что и у terminateActiveCall: своё уведомление в
  // приоритете, чужое — когда своего нет (ровно случай входящего звонка).
  const notification = findActiveCallNotification(client, room);
  const eventId = notification?.eventId ?? null;
  if (eventId) noteDismissedCallNotification(room.roomId, eventId);

  // Hangup is useful even when the notification event is absent (for example
  // after a limited sync); terminateActiveCall remains best effort.
  await terminateActiveCall(client, room);
  if (!eventId) return;
  try {
    await client.sendEvent(room.roomId, "org.matrix.msc4310.rtc.decline" as never, {
      "m.relates_to": { rel_type: "m.reference", event_id: eventId },
    } as never);
  } catch (error) {
    console.warn(`[call] decline signal failed room=${room.roomId}:`, error);
  }
}
